<nz-spin [nzSpinning]="loading$ | async">
  <div class="drawer-form-wrapper">
    <!-- Step Content -->
    <div
      class="feedback-content"
      [formGroup]="feedbackForm"
      *ngIf="isStepDataInitialized">
      <!-- Step 1: General Behavior Rating Step -->
      <app-general-behavior-step
        *ngIf="currentStep === 0 && getCurrentStepData()"
        [stepData]="getCurrentStepData()!"
        [formGroup]="feedbackForm"
        [overAllScore]="totalOverAllScore"
        [onNext]="nextStep.bind(this)"
        [onPrevious]="previousStep.bind(this)"
        [isFirstStep]="isFirstStep()">
      </app-general-behavior-step>

      <!-- Step 3: Intervention & Support Feedback Step -->
      <app-intervention-support-step
        *ngIf="currentStep === 2 && getCurrentStepData()"
        [stepData]="getCurrentStepData()!"
        [formGroup]="feedbackForm"
        [overAllScore]="totalOverAllScore"
        [onNext]="nextStep.bind(this)"
        [onPrevious]="previousStep.bind(this)">
      </app-intervention-support-step>

      <!-- Step 2: Behavior-Specific Metrics Step -->
      <app-behavior-metrics-step
        *ngIf="currentStep === 1 && getCurrentStepData()"
        [stepData]="getCurrentStepData()!"
        [feedbackDetails]="feedbackDetails"
        [formGroup]="feedbackForm"
        [overAllScore]="totalOverAllScore"
        [onNext]="nextStep.bind(this)"
        [onPrevious]="previousStep.bind(this)">
      </app-behavior-metrics-step>

      <!-- Step 4: Stakeholder Feedback Step -->
      <app-stakeholder-feedback-step
        *ngIf="currentStep === 3 && getCurrentStepData()"
        [stepData]="getCurrentStepData()!"
        [overAllScore]="totalOverAllScore"
        [formGroup]="feedbackForm"
        [onNext]="nextStep.bind(this)"
        [onPrevious]="previousStep.bind(this)">
      </app-stakeholder-feedback-step>

      <!-- Step 5: Self-Assessment Step -->
      <app-self-assessment-step
        *ngIf="currentStep === 4 && getCurrentStepData()"
        [stepData]="getCurrentStepData()!"
        [overAllScore]="totalOverAllScore"
        [formGroup]="feedbackForm"
        [onNext]="nextStep.bind(this)"
        [onPrevious]="previousStep.bind(this)"
        [onSubmit]="submitFeedback.bind(this)">
      </app-self-assessment-step>
    </div>

    <!-- Drawer Footer -->
    <div class="display-flex justify-content-between drawer-footer">
      <div class="footer-left">
        <button
          nz-button
          type="button"
          nzType="default"
          (click)="closeCorrectionNeededDrawer()">
          Cancel
        </button>
        <button
          *ngIf="!isFirstStep()"
          nz-button
          type="button"
          nzType="default"
          (click)="previousStep()">
          Prev
        </button>
      </div>

      <div class="footer-right">
        <button
          *ngIf="
            currentStep === 4 &&
            selfAssessmentStepComponent &&
            selfAssessmentStepComponent.selectedTabIndex === 1
          "
          nz-button
          [nzLoading]="isPrintLoading"
          type="button"
          nzType="default"
          (click)="printTemplate()">
          Print
        </button>
        <button
          *ngIf="!isLastStep()"
          nz-button
          type="button"
          nzType="primary"
          [disabled]="!isStepValid()"
          (click)="nextStep()">
          Next
        </button>

        <button
          *ngIf="isLastStep() && !isViewMode"
          nz-button
          type="button"
          nzType="primary"
          [disabled]="!isStepValid()"
          (click)="submitFeedback()">
          Save
        </button>
      </div>
    </div>
  </div>
</nz-spin>
